import { Grid } from "@mui/material";
import React from "react";
import OrderTypeShow from "../components/OrderTypeShow";
import OrderTypeSubmit from "../components/OrderTypeSubmit";

const OrderTypes = () => {
	return (
		<Grid
			container
			spacing={2}
			sx={{ maxWidth: "1200px !important", p: 2 }}
		>
			<Grid md={12}>
				<OrderTypeSubmit />
			</Grid>
			<Grid md={12}>
				<OrderTypeShow />
			</Grid>
		</Grid>
	);
};

export default OrderTypes;
